"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionsDataKey = exports.SuggestionsType = exports.Languages = exports.ClassYears = void 0;
exports.ClassYears = [
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th',
    '6th',
    '7th',
    '8th',
    '9th',
    '10th',
    '11th',
    '12th',
    '13th',
];
exports.Languages = ['German', 'English', 'Spanish', 'French'];
var SuggestionsType;
(function (SuggestionsType) {
    SuggestionsType["TOPIC"] = "topic";
    SuggestionsType["LEARNING_GOAL"] = "learning_goal";
})(SuggestionsType || (exports.SuggestionsType = SuggestionsType = {}));
var SuggestionsDataKey;
(function (SuggestionsDataKey) {
    SuggestionsDataKey["TOPIC"] = "topic";
    SuggestionsDataKey["LEARNING_GOAL"] = "learningGoal";
    SuggestionsDataKey["CLASS_YEAR"] = "grade";
    SuggestionsDataKey["SUBJECT"] = "subject";
})(SuggestionsDataKey || (exports.SuggestionsDataKey = SuggestionsDataKey = {}));
